
import { chargesStore1} from '../state/CommonState'
import Utils from "../util/Utils"
import { configStore } from "../state/CommonState"
import { Card } from "../v3-componets/AgCard"
import { Headspan } from "../v3-componets/AgHeadspan"
import pepiconspopperson from "../assets/images/pepicons-pop_person.svg";
import pepiconspopperson1 from "../assets/images/pepicons-pop_person1.svg";
import { groupedByCategory, PRICING_CATEGORY } from '../charges_data/LCLCharges'
import { Fragment } from 'react'
import RoleUtils from '../util/RoleUtils'
import { PERMISSIONS_NEW } from '../util/constants'
import TenantUtils from '../util/tenant.utils'
export default function LCLChargesViewv3(props) {
    let isMailBody=props.isMailBody
    let totalcurrency = "INR"
    if(props.totalcurrency!=undefined && props.totalcurrency.length>0){
        totalcurrency = props.totalcurrency
    }

    const Tn = ({ i, name }) => {
        const e = props.data[i]
        if (e.disabled && e.disabled.indexOf(name) >= 0)
            return (
                <div style={{ color: '#dddddd', border: 'none' }} >.</div>
            )
        else if (name === 'total') {
            return (
                <span style={{ textAlign: 'right' }}>{Utils.N(e[name], e.currency)}</span>
            )
        } else {
            let num = e[name]
            num = isNaN(num) ? 0.0 : Number(num)
            return num != 0 ? <span>{Utils.N(num, e.currency)}</span> : <></>
        }
    }

const num = (v) => {
  const n = Number(v);
  return isNaN(n) ? 0 : n;
};

const displayRec = (e) => {
  const perCBM = num(e.perCBM);
  const perTon = num(e.perTon);
  const perShipment = num(e.perShipment);
  const minimum = num(e.minimum);
  const maximum = num(e.maximum);
  const total = num(e.total);

  return (
    perCBM !== 0 ||
    perTon !== 0 ||
    perShipment !== 0 ||
    minimum !== 0 ||
    maximum !== 0 ||
    total !== 0
  );
};

    if (!props.data) {
        if (props.dummyContract!=undefined && props.dummyContract.chargesList!=undefined) {
            chargesStore1.list = props.dummyContract.chargesList
        }
        let listo = []
        let listc = []
        let lists = []
        let pkb = chargesStore1.pkb
        let rebate = chargesStore1.rebate
        for (let i = 0; i < chargesStore1.list.length; i++) {
            let e = chargesStore1.list[i]
            e = { ...e }
            if (e.onaccount && e.onaccount.startsWith('Cons')) listc.push(e)
            else if (e.onaccount && e.onaccount.startsWith('Ship')) lists.push(e)
            else listo.push(e)
        }
        return <>
        {
            (listo.length>0)?<LCLChargesViewv3 data={listo} chargeType='On Your Account'  dummyContract={props.dummyContract} isMailBody={isMailBody} totalcurrency={props.totalcurrency}/>:""
        }
        {
            (listc.length>0)?<LCLChargesViewv3 data={listc} 
            chargeType='On Consignee Account' dummyContract={props.dummyContract} isMailBody={isMailBody} totalcurrency={props.totalcurrency}/>:""
        }
        {
            (lists.length>0)?<LCLChargesViewv3 data={lists} chargeType='On Shipper Account' 
            dummyContract={props.dummyContract} isMailBody={isMailBody} totalcurrency={props.totalcurrency}/>:""
        } {
            (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATION.REBATE) && Array.isArray(rebate) && rebate.length>0 &&rebate[0].total != 0 && !isMailBody)?<LCLChargesViewv3 chargeType='Rebate' data={rebate} dummyContract={props.dummyContract} isMailBody={isMailBody} totalcurrency={props.totalcurrency} rebatePkb = {true}/>:""
        }
         {
             (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATION.PKB) &&Array.isArray(pkb) && pkb.length>0 && pkb[0].total != 0 && !isMailBody)?<LCLChargesViewv3 chargeType='Freight Commission' data={pkb} dummyContract={props.dummyContract} isMailBody={isMailBody} totalcurrency={props.totalcurrency}  rebatePkb = {true}/>:""
        }
        </>
    }
    let grandTotal = 0.0
    let volumeDiscount = 0.0
    props.data.map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        if (e.chargeDescription == 'Volume Discount') {
            volumeDiscount = (e.total * erate)
            if (volumeDiscount > 0) volumeDiscount *= -1
        } else if(e.chargeDescription !== 'Rebate'){
            grandTotal += parseFloat(e.total) * erate
        }
        console.log('E.TOTAL***=', e.total, grandTotal, e.currency, erate)
    })
    let counter = 1

    let checkValue = false;
    props.data.forEach(element => {
        if((+element.perCBM) !== 0 || (+element.perShipment) !== 0 || (+element.perTon) !== 0 || (+element.minimum) !== 0 || (+element.maximum) !== 0 || (+element.total) !== 0){
            checkValue = true;
        }
    });
    return (
        <>
            {checkValue ?
            <>
            <div style={{marginTop:"10px"}}>
                                <Card>
                                    {!props.isMailBody?<span><img src={props.chargeType=="On Your Account"?pepiconspopperson:pepiconspopperson1}/></span>:<></>}<Headspan color="#00000" fontSize= "14px" fontWeight="900" data={" "+props.chargeType}/>
                                    <div className="table-container">
                                    <table style={{border:"none", width:"100%"}}>
                    <thead>
  <tr>
    <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>#</th>
    <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", width: '20rem' }}>Charge Description</th>
    <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Currency</th>

    {!isMailBody && (
      <>
        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Per CBM</th>
        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Per Ton</th>
        {!props.rebatePkb?<th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Minimum</th>:<></>}
        {!props.rebatePkb?<th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Maximum</th>:<></>}
        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Per shipment</th>
        { props.chargeType == 'Freight Commission' && <>
                    <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR,padding: '10px' , textAlign: 'right' }}>Update By</th>
                    <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR,padding: '10px' , textAlign: 'right' }}>Update On</th>
                    </>
                  }
      </>
    )}

    <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Total</th>
  </tr>
</thead>

<tbody>
  {Object.entries(groupedByCategory(props.data)).map(([category, rows]) => {
    const displayRows = rows.filter(displayRec);
    if (displayRows.length === 0) return null;

    return (
      <Fragment key={category}>
        {/* <tr>
          <td colSpan={(!isMailBody ? 9 : 3)} style={{ background: "#EAF4FB", fontWeight: 900, padding: "10px", color: "#1E4E79" }}>
             {PRICING_CATEGORY[category]?.label}
          </td>
        </tr> */}

        {displayRows.map((e, rowIndex) => {
          const globalIndex = props.data.findIndex(x => x.id === e.id);

          return (
            <tr key={e.id} style={{ border:"solid 0.5px #D4D4D4", backgroundColor:(rowIndex % 2) ? "#F3F3F3" : "none" }}>
              <td style={{ padding: '10px' }}>{rowIndex+1}</td>
              <td style={{ padding: '10px' }}>{e.chargeDescription}</td>
              <td style={{ textAlign: 'center', padding: '10px'  }}>{e.currency}</td>

              {!isMailBody && (
                <>
                  <td style={{ padding: '10px' , textAlign: 'right' }}><Tn i={globalIndex} name="perCBM" /></td>
                  <td style={{ padding: '10px' , textAlign: 'right' }}><Tn i={globalIndex} name="perTon" /></td>
                  {!props.rebatePkb?<td style={{ padding: '10px' , textAlign: 'right' }}><Tn i={globalIndex} name="minimum" /></td>:<></>}
                  {!props.rebatePkb?<td style={{ padding: '10px' , textAlign: 'right' }}><Tn i={globalIndex} name="maximum" /></td>:<></>}
                  <td style={{ padding: '10px' , textAlign: 'right' }}><Tn i={globalIndex} name="perShipment" /></td>
                  { props.chargeType == 'Freight Commission' && <>
                    <td style={{ padding: '10px' , textAlign: 'right' }}>{(e.updateby!=undefined)?<>{e.updateby}</>:""}</td>
                    <td style={{ padding: '10px' , textAlign: 'right' }}>{(e.updateon!=undefined)?<>{Utils.formatToDateTime(Number(e.updateon))}</>:""}</td>
                    </>
                  }
                </>
              )}

              <td style={{ padding: '10px' , textAlign: 'right' }}><Tn i={globalIndex} name="total" /></td>
            </tr>
          )
        })}
      </Fragment>
    )
  })}
</tbody>


{props.chargeType !== 'Rebate' &&<tfoot>
  <tr style={{ border:"solid 0.5px #D4D4D4" }}>
    <td colSpan={(!isMailBody ? 8 : 3)} style={{ padding: '10px' , textAlign: 'right', fontWeight: 900 }}>
      TOTAL :
    </td>
    <td style={{ padding: '10px' , textAlign: 'right', fontWeight: 900 }}>
      {!props.isMailBody
        ? Utils.N(grandTotal + volumeDiscount)
        : Utils.N(configStore.changetotalcurrency(grandTotal + volumeDiscount, totalcurrency), totalcurrency)}
    </td>
  </tr>
</tfoot>}


                </table>
                                    </div>
                                </Card>
                                </div></> : <></>
            
    }</>
            
    )
}
